(function datePicker() {
    var dateInputs = $('input[type=date]');

    if (!Modernizr.inputtypes.date) {
        dateInputs.datepicker({
            inline: true,
            dateFormat: "dd/mm/yy",
            altFormat: "yy-mm-dd",
            showOn: 'button',
            onSelect: function () {
                $(this).attr('data-Is-Input-Focus-date-selection', 'true');
                //to trigger dateinput focus on dateselction 
                $(this).trigger('focus');
            }
        }).focus(function (e) {
            var isFocusOnDateSelection = $(this).attr('data-Is-Input-Focus-date-selection');
            //To counter opening date picker box on focus triggering
            if (isFocusOnDateSelection == "true") {
                e.stopImmediatePropagation();
                $(this).attr('data-Is-Input-Focus-date-selection', 'false');
            }
        });

        /*
        this creates customization of JQuery datepicker and adds 
        extra button markup
        */
        dateInputs.attr('placeholder', 'dd/mm/yyyy').
        wrap('<div class="m-datepicker"></div>').
        after('<span class="m-datepickerButton" role="button" aria-label="datepicker button"></span>');

        $('<style>input[type=date]::after{display:none}</style>')
        .appendTo('head');

        /*customize button can trigger datepicker*/
        $(".m-datepickerButton").on('click', function () {
            var dateInput = $(this).siblings('input');
            dateInput.datepicker('show');
        });
        //

        dateInputs.each(function () {
            var formattedDate = "";
            var initialValue = $(this).val();

            if (initialValue && initialValue != 'dd/mm/yyyy') {
                var existingDate = new Date(initialValue);
                formattedDate = existingDate.getDate() + "/" + (existingDate.getMonth() + 1) + "/" + existingDate.getFullYear();
            }

            var minDate = new Date($(this).attr('min'));

            $(this).datepicker("setDate", formattedDate);

            if (minDate) {
                $(this).datepicker('option', 'minDate', minDate);
                $(this).prop('min', false);
            }
        });
    }
    else {
        //for native datepickers, we don't need any validation. So disabling validation
        dateInputs.prop('data-val-regex', false).prop('data-val-regex-pattern', false).prop('data-val', false);
    }
})();